import { Component, Injector, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { COMMON_MODULES } from '@src/app/core/constants/common-module.constant';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { IMAGES_URL } from '@src/app/core/constants/system-list.constant';
import { HelperService, SharedDataService } from '@src/app/core/services';
import { ALL_SERVICES, CREAT_PASSWORD_PATH, COMPARE_MEDS_SEARCH, PHARMACY_LIST, PLUS_MEMBERSHIP, ROUTES } from '@src/app/core/constants';
import { CoreClass } from '@src/app/core/base/core.class';
import { environment } from '@src/environments/environment';
import { MiniEnvInfoCardComponent } from '@src/app/core/shared/components/ui/cardbox/mini-env-info-card/mini-env-info-card.component';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { MiniEnvBannerComponent } from "@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component";
import { MiniEnvFooterComponent } from '../../layout/mini-env/footer/footer.component';
import { MiniEnvSubFooterComponent } from '@src/app/core/shared/components/mini-env/mini-env-sub-footer/mini-env-sub-footer.component';
import { MembershipPlanComponent } from '@src/app/core/shared/components/membership-plan/membership-plan.component';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import * as faqsJson from '@src/assets/i18n/mini-env/acawellness/en.json';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';
import * as config from '@src/assets/tenant-assets/mini-env/mini-env-config.json';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { SearchInputComponent } from '@src/app/core/shared/components/search-input/search-input.component';
import { end } from '@popperjs/core';

declare var $: any;
@Component({
    selector: 'aca-wallness',

    templateUrl: './aca-wellness.component.html',
    styleUrl: './aca-wellness.component.scss',
    preserveWhitespaces: true,
    standalone: true,
    imports: [
        ...COMMON_MODULES,
        HeadingBlockOneModule,
        IconboxOneModule,
        IconboxTwoModule,
        HeadingBlockFullWidthModule,
        ImageboxOneModule,
        ImageboxFullwidthModule,
        CardboxOneModule,
        BannerOneModule,
        MiniEnvInfoCardComponent,
        ImageboxBulletScrollComponent,
        MiniEnvHeadingBlockComponent,
        MiniEnvFaqsComponent,
        MiniEnvBannerComponent,
        MembershipPlanModule,
        VideoPlayerComponent,
        MiniEnvContentBoxComponent,
        SearchInputComponent
    ]
})
export class ACAWellnessComponent extends CoreClass implements OnInit {
    testimonials: any = [];
    blogs: any = [];
    IMAGES_URL: string = IMAGES_URL;
    faqList = faqsJson.FAQS.FAQ_LIST;
    imgSrc = `assets/tenant-assets/mini-env/images/people-in-kitchen.png`;
    isLoading = false
    noData = false
    environment = environment;

    // public language: string = ""
    // style = 'font-size: 64px;line-height: 78px';
    constructor(
        injector: Injector,
        private httpClient: HttpClient,
        private helperService: HelperService
    ) {
        super(injector);
    }
    All_SERVICES_PATH: string = ALL_SERVICES;
    membershipCode = ''


    getMedicines(drugName = '') {
        this.isLoading = true;
        let endpoint =
            `${COMPARE_MEDS_SEARCH}${encodeURIComponent(drugName)}&serviceName=${encodeURIComponent('Walker Pharmacy')}`;
        if (drugName == '') {
            this.isLoading = false
            this.sharedService.results = [];
            return;
        }

        console.log("testin end point", endpoint)

        this.httpService.requestEntity('GET', endpoint,)
            // .pipe(takeUntil(this.onDestroy$))
            .subscribe((res: any) => {

                let response = res.body;
                this.sharedService.results = response.data;
                this.isLoading = false
                response.data.length === 0 ? this.noData = true : this.noData = false
            },
                (error: any) => {
                    this.isLoading = false
                }
            )
    }

    buttonAction() {
        const section = document.getElementById('membership-section');

        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    panes: any[] = [
        {
            tabTitle: 'Vision Care', heading: 'Vision Care', subHeading: 'Your eyes deserve the best care, without the hassle. From discounted eyewear to a vast provider network and smart home delivery, we make vision care simple, affordable, and accessible.', active: false, pointsList: [
                { title: 'Discounted Eye care', description: 'Enjoy savings on glasses and contact lenses, plus access to a free online eye exam (where allowed).' },
                {
                    title: 'Nationwide Network', description: 'Choose from 100,000+ providers nationwide so you get expert care wherever you are.'
                },
                { title: 'Smart Convenience', description: 'Explore and try on frames using our AI-powered member portal, then have your perfect pair delivered straight to your door.' },

            ]
        },
        {
            tabTitle: 'Dental benefits', heading: 'Dental benefits', subHeading: 'Connect with affordable, high-quality dental care through a nationwide network, empowering you to take charge of your oral health with confidence.', active: false, pointsList: [
                { title: 'Big Savings', description: 'Save up to 60% on a wide range of dental procedures, including routine cleanings, X-rays, fillings, crowns, and more.' },
                { title: 'Wide Network', description: 'Choose from over 263,000+ dental practice locations nationwide, giving you the flexibility to find trusted care wherever you are.' },
                { title: 'Upfront Pricing', description: 'Pay directly at the time of service with full price transparency, no hidden charges, no surprise bills, and no complicated paperwork.' }
            ]
        },
        {
            tabTitle: 'Virtual care services', heading: 'Virtual care services', subHeading: 'Access round-the-clock virtual care and counseling services designed for your physical and mental well-being, anytime you need them.', active: false, pointsList: [
                { title: 'Virtual Primary Care', description: 'Schedule appointments with licensed doctors of your choice for routine checkups, ongoing health concerns, and continuous — all from the comfort of your home.' },
                { title: '24/7 Virtual Urgent Care', description: 'Get immediate medical attention for non-emergency issues available anytime, day or night.' },
                {
                    title: 'Confidential Mental Health Counseling', description: 'Speak with trained professionals in private, virtual sessions to manage stress, anxiety, and emotional well-being.'
                },
            ]
        },
        {
            tabTitle: 'Pharmacy benefits', heading: 'Pharmacy Benefits', subHeading: 'Enjoy convenient and cost-effective pharmacy options, designed to make healthcare more accessible when it matters most.', active: false, pointsList: [
                { title: 'Free Generic Medications', description: 'Get essential drugs for diabetes, high blood pressure, birth control, pain relievers, antibiotics, etc. at zero cost from your local pharmacy.' },
                { title: 'Local Pharmacy Access', description: 'Pick up all medications at discounted rates from over 70,000 local pharmacies.' },
                { title: 'Discounted Brand Medication', description: 'Get brand-name medications at significant discounts from Tier-1 countries (UK, Canada, Australia, New Zealand) with free home delivery.' }
            ]
        },

    ];

    services = [
        {
            id: '01',
            title: 'Urgent Care',
            description: '24/7 available virtual urgent care for non-life-threatening situations.',
            icon: 'siren 1.png',
            isFree: true,
            link: ROUTES.virtualUrgentCare
        },
        {
            id: '02',
            title: 'Mental Health Counseling',
            description: 'Mental health support with certified mental health specialists.',
            icon: 'mental-health 1.png',
            isFree: true,
            link: ROUTES.mentalHealth
        },
        {
            id: '03',
            title: 'Medications',
            description: 'Free generics, with discounts on brand-name prescriptions.',
            icon: 'medicine (2) 1.png',
            isFree: true,
            link: ROUTES.pharmacy
        },
        {
            id: '08',
            title: 'Imaging',
            description: 'Clear, transparent, and discounted rates at 4,000+ labs nationwide.',
            icon: 'mri-machine 1.png',
            isFree: false,
            link: ROUTES.imaging
        },
        {
            id: '04',
            title: 'Office Visits',
            description: 'Save up to 35% with 350k+ doctors nationwide.',
            icon: 'hospital (1) 1.png',
            isFree: false,
            link: ROUTES.officeVisit
        },


        {
            id: '07',
            title: 'Lab Tests',
            description: 'Save up to 60% at 2,100+ lab locations.',
            icon: 'test-tube 1.png',
            isFree: false,
            link: ROUTES.labTest
        },



        {
            id: '09',
            title: 'Procedures',
            description: 'Save 50%+ on procedures at 5,000+ surgery centers.',
            icon: 'robotic-surgery 1.png',
            isFree: false,
            link: ROUTES.surgical
        }];

    faqs: any[] = [
        {
            question: 'What is the WoW Health Pharmacy plan?',
            answer: 'WoW Health aims to remove barriers to healthcare. Our pharmacy plan gives access to over 400 medications at zero cost when home delivered, or you can choose to pick it up at a steep discount from a local pharmacy. Also, over 40 common urgent care medications are available at zero cost at your local pharmacy as well. The home delivery option covers about 95% of the most prescribed maintenance medications in the US!'
        },
        {
            question: 'Is the home delivery always free?',
            answer: 'Our home delivery service allows you to get a 3-month supply of medications at one time. You can add all of your medications in one shipment, and you are allowed up to 6 shipments free per year. After the first 6 free shipments, there is a charge of only $5 per shipment.'
        },
        {
            question: 'What if I need a medication urgently?',
            answer: 'There are certain times, especially with infections, when you can’t wait for the shipment. In that case, you can pick up your medication at the local pharmacy, and since our plan covers most of these common urgent care medications, there is zero cost even when picking up these medications at the local pharmacy.'
        },
        {
            question: 'What happens when I become a member?',
            answer: 'Once your WoW Health membership becomes active, you will be able to get to your pharmacy portal with one click which will allow you to search medications, and see all of your options, like home delivery vs local pick up, and pricing so you can decide what works best for you.'
        },
        {
            question: 'If I go to the pharmacy, do I need to show my membership card to the pharmacist?',
            answer: 'Yes, you will need to bring your membership card that allows the pharmacy to verify that you are active, and the amount due (if any) because most urgent care medications are free even when picked up at the local pharmacy.'
        }
    ];

    steps = [
        {
            id: '01',
            title: '01. Secure Login',
            description: 'Access your account and personal dashboard.'
        },
        {
            id: '02',
            title: '02. Browse Services',
            description: 'Explore all available healthcare services.'
        },
        {
            id: '03',
            title: '03. Select & Start',
            description: 'Choose a service to begin your request.'
        },
        {
            id: '04',
            title: '04. Instant Support',
            description: 'Contact our 24/7 team for any help.'
        },
    ];

    bannerSlides: any[] = [
        {
            title: 'A Modern Approach to Preventive Health',
            subtitle: 'From virtual care to dental and pharmacy savings, ACA Solutions brings together essential benefits that keep you healthy and financially protected.',
            discription: '',
            buttonText: 'Login',
            buttonAction: 'login',
            buttonAction2: 'first-login',
            buttonText2: 'First Time Login',
            bannerClass: 'amac-banner',
            bgImageUrl: `/assets/tenant-assets/mini-env/images/aca-wellness.png`,
            link: '/join'
        }
    ];

    ngOnInit(): void {
        this.sharedService.removeNavbarLinks = false; 
        this.helperService.changeMiniEnvColor()

        // Default the search zip code field to the logged-in user's zip code;
        // fall back to the default zip for guests or users without one on file.
        this.sharedService.pharmacyInfo.zipCode =
            this.storageService.getUserInformation()?.zipCode || "48243";

        this.handleRedirect();
    }

    // Handles links like /acawellness/?redirect=/pharmacies-list
    // by sending the user to the requested in-app page (e.g. the
    // Walker Pharmacy medication list).
    handleRedirect(): void {
        const redirect = this.activatedRoute.snapshot.queryParams['redirect'];
        if (!redirect) {
            return;
        }

        if (redirect === ROUTES.pharmacyList || redirect === PHARMACY_LIST || redirect === `/${PHARMACY_LIST}`) {
            this.router.navigateByUrl(ROUTES.pharmacyList);
        }
    }
    getTestimonials() {
        // this code need improvement
        const apiUrl = `/assets/tenant-assets/testimonials/en.json`;
        this.httpClient.get(apiUrl).subscribe((data: any) => {
            this.testimonials = data; // Assign the data to the property
        });
    }
    getBlogs() {
        // this code need improvement
        const apiUrl = `/assets/tenant-assets/blogs/en.json`;
        this.httpClient.get(apiUrl).subscribe((data: any) => {
            this.blogs = data; // Assign the data to the property
        });
    }

    // buttonAction() {
    //     const section = document.getElementById('membership-section');

    //     if (section) {
    //         section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    // }

    onSliderBtnAction(action: any) {
        if (action == 'login') {
            this.login();
        } else {
            this.router.navigate([CREAT_PASSWORD_PATH]);
        }
    }

    getStartedAction() {
        this.router.navigateByUrl(PLUS_MEMBERSHIP);
    }

    ngAfterContentInit(): void {
        const panesArray = this.panes;

        // Ensure one tab is active
        const activePane = panesArray.find(p => p.active);
        if (!activePane && panesArray.length) {
            panesArray[0].active = true;
        }
    }

    select(index: number): void {
        this.panes.forEach((pane, i) => {
            pane.active = i === index;
        });
    }
    login() {
        this.router.navigateByUrl(ROUTES.login);
    }
}

